import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './RecordIconScroll.module.css';
import ImageWithFallback from '../GenericComponents/ImageWithFallback';
import { getImages } from '../Result/getImages';

interface RecordIconScrollProps {
    record: any;
    index: number;
    handleLinkClick: (event: React.MouseEvent, index: number) => void;
}

const RecordIconScroll: React.FC<RecordIconScrollProps> = React.memo(({ record, index, handleLinkClick }) => {
    const { t } = useTranslation();
    const [isHovered, setIsHovered] = useState(false);

    let imageUrl = "";
    const allImages = getImages(record);
    if ((allImages as any)["iconscroll"]?.length > 0) {
        imageUrl = (allImages as any)["iconscroll"][0]?.url;
    }

    const invNo = record?.data?.Record?.ObjectNumber;
    const [hasBeenShown, setHasBeenShown] = useState(false);
    const iconRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!hasBeenShown && iconRef.current) {
            setTimeout(() => {
                iconRef.current?.classList.add(styles.fadeIn);
                setHasBeenShown(true);
            }, 50);
        }
    }, [hasBeenShown]);

    function getTitle(record: any) {
        const titleData = record?.data?.record?.title?.title;
        return (
            <div className={styles.row}>
                {titleData ? <strong>{titleData}</strong> : <div className={styles.row}>{t('')}</div>}
                <br />
            </div>
        );
    }

    function dataIcon(record: any) {
        const values = [
            record?.data?.record?.objectnumber,
            record?.data?.record?.sitename,
            record?.data?.record?.lastname,
            record?.data?.record?.firstname,
            record?.data?.record?.nationality,
            record?.data?.record?.condated,
            record?.data?.record?.eventname,
            record?.data?.record?.exhtitle,
            record?.data?.record?.institution,
            record?.data?.record?.institutions,
            record?.data?.record?.displayname,
            record?.data?.record?.displaydate,
        ].filter(Boolean); // Verwijdert lege waarden

        if (values.length === 0) {
            return <div className={styles.row}>{t("No information available")}</div>;
        }

        return (
            <div className={styles.row}>
                {values.map((value, index) => (
                    <div key={index}>
                        <strong>{value}</strong>
                        <br /><br />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div key={index}>
            <a
                href={`${window.location.pathname}?action=search&field=/Record/ObjectNumber&label=N°%20de%20gestion&value=${invNo}`}
                className={styles.RecordIcon}
                key={index}
                onClick={(event) => handleLinkClick(event, index)}
                onMouseDown={e => e.preventDefault()}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div className={styles.iconViewRecord}>
                    {imageUrl && (
                        <ImageWithFallback 
                            src={imageUrl} 
                            alt="Image" 
                            placeholder={`${process.env.REACT_APP_IMAGE_BASE_URL}images/nondisponible.cci&width=180`} 
                        />
                    )}

                    {isHovered && (
                        <div className={styles.hoverOverlay}>
                            {getTitle(record)}
                            {dataIcon(record)}
                        </div>
                    )}
                </div>
            </a>
        </div>
    );
});

export default RecordIconScroll;
